import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';



const Loader = (props) => {

  const StyledGrid = styled(Grid)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: props?.height ? props?.height : '100vh',
    'span': {
      height: '35px !important',
      width: '35px !important',
      color: 'grey'
    }
  });

  return (
    <StyledGrid>
      <CircularProgress color="inherit" />
    </StyledGrid>
  );
};

export default Loader;

